import { render } from "./AutreService.vue?vue&type=template&id=5ddcd4a0&ts=true"
import script from "./AutreService.vue?vue&type=script&lang=ts"
export * from "./AutreService.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__